module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-with-tree-98838db38de88c248af3ee5f682fe71e.svg";